import { AnimatePresence, motion } from 'framer-motion';
import { scaleMotionProps } from '../../utils/framerProps';
import Icons from '../../assets/index';
import '../../index.css';

type PopupProps = {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  title: string;
  zIndex?: number;
};

const Popup = ({ isOpen, children, onClose, title, zIndex }: PopupProps) => {
  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="fixed inset-0 bg-black opacity-30 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.3 }}
              exit={{ opacity: 0 }}
              data-testid="popup-overlay"
              style={{ zIndex: (zIndex ?? 50) - 10 }}
            />
            <motion.div
              data-testid="popup-container"
              {...scaleMotionProps}
              style={{ zIndex: zIndex ?? 50 }}
              className="fixed inset-0 flex items-center justify-center z-50"
            >
              <div className="w-[460px] bg-white rounded-2xl p-6 shadow-2xl relative">
                {/* Header */}
                <div className="flex justify-between items-center mb-3">
                  <h5 className="text-lg font-semibold">{title}</h5>
                  <button data-testid="close-icon" onClick={onClose}>
                    <Icons.closeIcon />
                  </button>
                </div>
                {/* Popup Content */}
                {children}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Popup;
